module.exports = __webpack_public_path__ + "static/media/artwork.0b56b69d.jpg";